module.exports = __webpack_public_path__ + "arrow-right.1lRdHW5A.svg";